import React, { ReactNode } from 'react';

type ProfilePageSectionContainerProps = {
  className?: string;
  children?: ReactNode;
};

export default function ProfilePageSectionContainer(props: ProfilePageSectionContainerProps) {
  return <div className={`px-8 ev-sm:px-20 w-full ${props.className}`}>{props.children}</div>;
}
